export enum GameStep {
  HOME = "HOME",
  LOGIN = "LOGIN",
  CATEGORY = "CATEGORY",
  GAME = "GAME",
  GAMERESULT = "GAMERESULT",
  BANIBON = "BANIBON",
  CHANCE = "CHANCE",
  LUCKYUER = "LUCKYUER",
}
export enum LoginSteps {
  PHONE = "phone",
  OTP = "otp",
}
export enum ModalStep {
  LUCKY = "lucky",
  CHANCE = "chance",
  RULE = "rule",
  LOGOUT = "logout",
  LOGIN = "login",
  BRANDS = "brands",
  DEFAULT = "default",
}
